import type { UseTranslationResponse } from 'react-i18next';
import { useTranslation } from 'react-i18next';

const namespace = 'entities';
const keyPrefix = 'user_filters';
export const useUserFiltersTranslation = (): UseTranslationResponse<typeof namespace> => {
  return useTranslation(namespace, { keyPrefix });
};

export const ruRu = ({
  [keyPrefix]: {
    role_id: {
      label: 'Роль',
    },
    department_id: {
      label: 'Подразделение',
    },
    last_login_at: {
      label: 'Последний вход',
    },
    full_name: {
      label: 'Имя',
    },
    email: {
      label: 'Email',
    },
    user_id: {
      label: 'ID пользователя',
    },
    create_time: {
      label: 'Дата создания',
    },
    reset: 'Очистить',
    sort: {
      full_name_asc: 'По имени (от А до Я)',
      full_name_desc: 'По имени (от Я до А)',
      last_login_at_asc: 'По последнему входу (сначала старые)',
      last_login_at_desc: 'По последнему входу (сначала новые)',
      create_time_asc: 'По дате создания (сначала старые)',
      create_time_desc: 'По дате создания (сначала новые)',
      update_time_asc: 'По дате изменения (сначала старые)',
      update_time_desc: 'По дате изменения (сначала новые)',
    },
  },
}) as Record<string, unknown>;

export const en = ({
  [keyPrefix]: {
    role_id: {
      label: 'Role',
    },
    department_id: {
      label: 'Subdivision',
    },
    last_login_at: {
      label: 'Last login at',
    },
    full_name: {
      label: 'Name',
    },
    email: {
      label: 'Email',
    },
    user_id: {
      label: 'User ID',
    },
    create_time: {
      label: 'Date created',
    },
    reset: 'Reset',
    sort: {
      full_name_asc: 'By name (A to Z)',
      full_name_desc: 'By name (Z to A)',
      last_login_at_asc: 'By last login (oldest first)',
      last_login_at_desc: 'By last login (newest first)',
      create_time_asc: 'By creation date (oldest first)',
      create_time_desc: 'By creation date (newest first)',
      update_time_asc: 'By update date (oldest first)',
      update_time_desc: 'By update date (newest first)',
    },
  },
}) as Record<string, unknown>;

export const esEs = ({
  [keyPrefix]: {
    role_id: {
      label: 'Role',
    },
    department_id: {
      label: 'Subdivisión',
    },
    last_login_at: {
      label: 'Último inicio de sesión',
    },
    full_name: {
      label: 'Nombre',
    },
    email: {
      label: 'Email',
    },
    user_id: {
      label: 'ID de usuario',
    },
    create_time: {
      label: 'Fecha de creación',
    },
    reset: 'Reiniciar',
    sort: {
      full_name_asc: 'Por nombre (de A a Z)',
      full_name_desc: 'Por nombre (de Z a A)',
      last_login_at_asc: 'Por último acceso (más antiguos primero)',
      last_login_at_desc: 'Por último acceso (más recientes primero)',
      create_time_asc: 'Por fecha de creación (más antiguos primero)',
      create_time_desc: 'Por fecha de creación (más recientes primero)',
      update_time_asc: 'Por fecha de actualización (más antiguos primero)',
      update_time_desc: 'Por fecha de actualización (más recientes primero)',
    },
  },
}) as Record<string, unknown>;

export const ptBr = ({
  [keyPrefix]: {
    role_id: {
      label: 'Papel',
    },
    department_id: {
      label: 'Subdivisão',
    },
    last_login_at: {
      label: 'Último login',
    },
    full_name: {
      label: 'Nome',
    },
    email: {
      label: 'Email',
    },
    user_id: {
      label: 'ID do usuário',
    },
    create_time: {
      label: 'Data de criação',
    },
    reset: 'Reiniciar',
    sort: {
      full_name_asc: 'Por nome (A a Z)',
      full_name_desc: 'Por nome (Z a A)',
      last_login_at_asc: 'Por último login (mais antigos primeiro)',
      last_login_at_desc: 'Por último login (mais recentes primeiro)',
      create_time_asc: 'Por data de criação (mais antigos primeiro)',
      create_time_desc: 'Por data de criação (mais recentes primeiro)',
      update_time_asc: 'Por data de atualização (mais antigos primeiro)',
      update_time_desc: 'Por data de atualização (mais recentes primeiro)',
    },
  },
}) as Record<string, unknown>;
